//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/eros/actions';
import type { SubmittedForm$Props } from './flowTypes'

class SubmittedForm extends React.Component<SubmittedForm$Props> {
    componentWillUpdate(){
        const { eros } = this.props;
    
        if (eros.invoiceSubmitted) {
            this.props.invoiceSubmissionCompleted();
        }
    }

    render(){
        return (
            <div className="container">
                <div className="row">
                    <br />
                </div>
                <div className="row">
                    <h3>Invoice Data Extraction</h3>
                </div>
                <div className="row">
                    <div className="alert alert-success" role="alert">
                         Your task has been submitted successfully.
                    </div>
                </div>    
            </div>
        )
    }
    
}

const mapStateToProps:any = (state, ownProps) => {
    return {
        eros: state.eros
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      invoiceSubmissionCompleted: () => {
         dispatch(actions.invoiceSubmissionCompleted())  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(SubmittedForm);


// WEBPACK FOOTER //
// ./src/views/ProjectEros/SubmittedForm.js